import { AdministrationPage } from '@/features/mocked/administration'
import { FEATURES, isFeatureEnabled } from '@/utils/feature-flag.ts'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$companySlug/administration/')({
  beforeLoad: () => {
    if (!isFeatureEnabled(FEATURES.ADMINISTRATION)) {
      throw redirect({
        to: '/not-found'
      })
    }
  },
  component: AdministrationRoute
})

function AdministrationRoute() {
  return <AdministrationPage />
}
